import React from 'react'
import HeroBanner from '../component/Common Banner Component/HeroBanner'
import Sponsor from '../component/Sponsor/Sponsor'
import TextContent from '../component/TextContent/TextContent'
import CardCarousel from "../component/CardCarousel/CardBlog"
import Testimonials from "../component/Testimonials/Testimonials"
import Footer from '../component/Footer/Footer'
import VideoContent from '../component/VideoContent/VideoContent'
import DiscoverServices from "../component/DiscoverServices/DiscoverServices"
import DropDownContent from '../component/DropDownContent/DropDownContent'
import Contactform from '../component/Contact Form/Contactform'
import { Helmet } from 'react-helmet'
import InteriorDesign from '../component/InteriorDesign/InteriorDesign'
import ProjectGlance from '../component/ProjectGlance/ProjectGlance'
import BlogCard from '../component/BlogCard/BlogCard'
import HomeHero from '../component/HomeHero/HomeHero'
import PlainTextContent from '../component/PlainTextContent/PlainTextContent'
import PlainImgTextContent from '../component/PlainImgTextContent/PlainImgTextContent'
import FooterNew from '../component/FooterNew/FooterNew'


const textDropDown = [
    {
      title:"Coaching & Clinicians",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
    },
    {
      title:"Rider Development Program",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
    }
  ]

function Home() {
  return (
    <div >
      
      <HomeHero/>
        
      
      {/* <HeroBanner 
        subHeading=""
        Heading="Dare to be you.Tell it boldly. "
        nextLineSpanHeading=""
        Paragraph=""
        bgImg="/images/creatives/plain-hero-bg.png"
        btn={true}
        btnRef='/'
        btnText={"Book a Discovery Call"}
        sideLinks={false}
      /> */}

    {/* <Sponsor
        textSection={false}
      /> */}

      <PlainTextContent
      heading='Marketing that Starts with You'
      content={'At Divitiis, we help professionals own their voice and lead with confidence through bold, strategic storytelling.\n Our approach blends tailored strategy with authentic messaging that reflects who you truly are.'}
      btnText='Learn More'
      btnRef='/about'
      bgColor="#3D4335"
      fontThemeDark={false}
      btnClass='btn-pink'
      /> 
      {/* <PlainImgTextContent
       heading='Marketing that Starts with You'
      content={'At Divitiis, we help professionals own their voice and lead with confidence through bold, strategic storytelling.\n Our approach blends tailored strategy with authentic messaging that reflects who you truly are.'}
      btnText='Learn More'
      btnRef='/meet-the-strategist'
      bgColor="#3D4335"
      fontThemeDark={false}
      btnClass='btn-pink'
        contentImg='/images/NewAssets/creatives/home-text-1.jpg'
      /> */}

      <PlainTextContent
      heading='How We Work'
      content={'Every brand has a story and a strategy to match. Our 6-step approach helps you grow with clarity, confidence, and authenticity.'}
      btnText='See Our Process'
      btnRef='/process'
      bgColor="white"
      fontThemeDark={true}
      btnClass='btn-brown'
      />

      <PlainImgTextContent
        heading='Meet the Strategist Behind Divitiis'
        content={'I’m here to help you stop blending in and start owning your space.'}
        btnText='More About Betsy'
        btnRef='/meet-the-strategist'
        bgColor="#3D4335"
        fontThemeDark={false}
        btnClass='btn-pink'
        contentImg='/images/NewAssets/creatives/home-text-1.jpg'
        shortImg={true}
      />

      <PlainTextContent
      heading='Ready to Lead with Your Story?'
      content={"Let's build a brand that's bold, real and uniquely yours."}
      btnText='Book a Discovery Call'
      btnRef='/contact'
      bgColor="#DBD3C6"
      fontThemeDark={true}
      btnClass='btn-brown'
      />


      {/* <TextContent
         subHeading=""
         heading= ""
         content=""
         btn={true}
         btnText="ABOUT US"
         btnRef='/about'
         shiftRow={true}
         img="/images/creatives/home-text-1.png"
         reviewContent={false}
         btnImg={true}
         fontDark={true}
         /> */}

        <FooterNew/>

</div>
  )
}

export default Home